import axios from './_nestAxios'

export const actualizarCompra = (_id, data) => axios.put(`/compras/${_id}`, data)

export const eliminarCompra = _id => axios.delete(`/compras/${_id}`)

export const nuevaCompra = data => axios.post('/compras', data)

export const regularizarAsientoxId = id => axios.post(`/compras/${id}/regularizar-asiento`)

export const getCompra = _id => axios.get(`/compras/${_id}`)

export const descargarReporteCompra = params => axios.get('/compras/descargarReporte', { responseType: 'blob', params })

export const descargarReporteOrdenes = params => axios.get('/compras/descargarReporteOrdenes', { responseType: 'blob', params })

export const descargarFormatoCruceComprasContabilidad = params =>
  axios.get('/compras/descargarCruceComprasContabilidad', { responseType: 'blob', params })

export const imprimirCompraxId = _id => axios.get(`compras/${_id}/imprimirPdf`, { responseType: 'blob' })

export const imprimirNotaxId = _id => axios.get(`compras/${_id}/imprimirNotaCrdtxId`, { responseType: 'blob' })

export const getCompraEstadoCuenta = _id => axios.get(`/compras/${_id}`, { params: { tipoConsulta: 'estado-cuenta' } })

export const descargarFormatoCruceComprasKardex = data => axios.get('/compras/descargarCruceComprasKardex', { responseType: 'blob', params: data })
export const consultaCruceComprasKardex = params => axios.get('/compras/consultaCruceComprasKardex', { params })
